import { api } from '@/api/axios';

export interface UploadedFile {
  id: string;
  originalName: string;
  storedName: string;
  relativePath: string;
  publicUrl: string;
  mimeType: string;
  size: number;
}

interface UploadBase64Payload {
  fileName: string;
  mimeType: string;
  base64: string;
  folder?: string;
}

interface UploadBase64Response {
  success: boolean;
  data: UploadedFile;
  message: string;
}

export const fileService = {
  async uploadBase64(payload: UploadBase64Payload): Promise<UploadedFile> {
    const { data } = await api.post<UploadBase64Response>('/files/upload-base64', payload);
    return data.data;
  },
};
